import React from 'react';
import { gameTimerModeNames, restUrl, autoRefreshIntervalSeconds } from '../../env';
import { WaitUntilLoggedIn } from '../Core/LoginManager'
import axios from 'axios';
import { analytics } from '../Core/AnalyticsManager';

const ROOMS_INDEX = 0;
const SPECTATE_INDEX = 1;

export default class JoinRoom extends React.Component
{
  state = {
    selectedTabIndex: 0,
    rooms: [],
    spectateRooms: [],
    autoRefreshEnabled: true,
    autoRefreshProgress: 0
  };

  panelTabs = [ "ROOMS", "SPECTATE" ];

  // Flag to prevent duplicate initialization in React Strict Mode
  isInitialized = false;

  // Auto-refresh timer references
  autoRefreshTimer = null;
  progressTimer = null;

  async componentDidMount()
  {
    // Prevent duplicate initialization in React Strict Mode
    if( this.isInitialized )
    {
      return;
    }
    this.isInitialized = true;

    await WaitUntilLoggedIn( async () =>
    {
      await this.updatePlayableRoomsList();

      // Start auto-refresh since it's enabled by default
      if( this.state.autoRefreshEnabled )
      {
        this.startAutoRefresh();
      }
    } );
  }

  componentWillUnmount()
  {
    this.stopAutoRefresh();
  }

  updateCurrentRoomsList = async () =>
  {
    await this.updateRoomsListByIndex( this.state.selectedTabIndex );
  }

  updateRoomsListByIndex = async ( index ) =>
  {
    if( index === 0 )
    {
      await this.updatePlayableRoomsList();
    }
    else
    {
      await this.updateSpectateRoomsList();
    }
  }

  updatePlayableRoomsList = async () =>
  {
    try
    {
      const response = await axios.post( `${restUrl}/lobby/rooms`, {}, { withCredentials: true } );

      if( response && response.data.success && Array.isArray( response.data.rooms ) )
      {
        this.setState( { rooms: response.data.rooms } );
      }
    }
    catch( error )
    {
      console.log( "lobby/rooms request failed with error: ", error );
    }
  }

  updateSpectateRoomsList = async () =>
  {
    try
    {
      const response = await axios.post( `${restUrl}/lobby/rooms-spectate`, {}, { withCredentials: true } );

      if( response && response.data.success && Array.isArray( response.data.rooms ) )
      {
        this.setState( { spectateRooms: response.data.rooms } );
      }
    }
    catch( error )
    {
      console.log( "lobby/rooms-spectate request failed with error: ", error );
    }
  }

  toggleAutoRefresh = () =>
  {
    const newAutoRefreshEnabled = !this.state.autoRefreshEnabled;

    this.setState( { autoRefreshEnabled: newAutoRefreshEnabled } );

    if( newAutoRefreshEnabled )
    {
      analytics.track( 'autoRefreshEnabled' );
      this.startAutoRefresh();
    } else
    {
      analytics.track( 'autoRefreshDisabled' );
      this.stopAutoRefresh();
    }
  }

  startAutoRefresh = () =>
  {
    this.stopAutoRefresh(); // Clear any existing timers

    const intervalMs = autoRefreshIntervalSeconds * 1000;
    const progressUpdateInterval = 100; // Update progress every 100ms

    let progressValue = 0;

    // Update progress bar
    this.progressTimer = setInterval( () =>
    {
      progressValue += progressUpdateInterval;
      const progressPercent = ( progressValue / intervalMs ) * 100;

      if( progressValue >= intervalMs )
      {
        progressValue = 0;
      }

      this.setState( { autoRefreshProgress: progressPercent } );
    }, progressUpdateInterval );

    // Auto refresh timer
    this.autoRefreshTimer = setInterval( async () =>
    {
      await this.updateCurrentRoomsList();
      analytics.track( 'autoRefreshTriggered' );
    }, intervalMs );
  }

  stopAutoRefresh = () =>
  {
    if( this.autoRefreshTimer )
    {
      clearInterval( this.autoRefreshTimer );
      this.autoRefreshTimer = null;
    }

    if( this.progressTimer )
    {
      clearInterval( this.progressTimer );
      this.progressTimer = null;
    }

    this.setState( { autoRefreshProgress: 0 } );
  }


  onJoinRoom = event =>
  {
    event.preventDefault();

    // Process the forms input data to get the room ID
    const formData = new FormData( event.target );
    const formDataObj = Object.fromEntries( formData.entries() );

    const roomId = formDataObj.roomId;

    const { onJoinRoom } = this.props;

    onJoinRoom( { roomId } );
  };



  render()
  {
    const { selectedTabIndex, autoRefreshEnabled, autoRefreshProgress } = this.state;

    let roomsData;

    if( selectedTabIndex === ROOMS_INDEX )
    {
      roomsData = this.state.rooms;
    }
    else
    {
      roomsData = this.state.spectateRooms;
    }

    // roomsData = [
    //   { roomId: 'f7h29', name: '#f7h29 -- TomsLocal', players: 1, maxPlayers: 4, gameTimer: 0, gameMode: 0 },
    //   { roomId: 'g8924', name: '#g8924 -- Farts123', players: 2, maxPlayers: 3, gameTimer: 3, gameMode: 0 },
    //   { roomId: 'g24h2', name: '#g24h2 -- Johnny', players: 3, maxPlayers: 4, gameTimer: 2, gameMode: 0 },
    //   { roomId: 'h5j6h', name: '#h5j6h -- Lollers', players: 3, maxPlayers: 4, gameTimer: 1, gameMode: 0 },
    //   { roomId: '4h35h', name: '#4h35h -- HardyHa', players: 1, maxPlayers: 2, gameTimer: 3, gameMode: 0 },
    //   { roomId: '4gh24', name: '#4gh24 -- ComeOnThen', players: 1, maxPlayers: 4, gameTimer: 0, gameMode: 0 },
    //   { roomId: 'gk5h3', name: '#gk5h3 -- FarmerBoi', players: 1, maxPlayers: 2, gameTimer: 0, gameMode: 0 },
    //   { roomId: '436f7', name: '#436f7 -- CloisterZ', players: 1, maxPlayers: 2, gameTimer: 1, gameMode: 0 },
    //   { roomId: '00hrh', name: '#00hrh -- RoadHOG', players: 2, maxPlayers: 3, gameTimer: 0, gameMode: 0 },
    //   { roomId: 'rgr0g', name: '#rgr0g -- GoldFIeld', players: 2, maxPlayers: 4, gameTimer: 1, gameMode: 0 },
    //   { roomId: 'f7h29', name: '#f7h29 -- TomsLocal', players: 1, maxPlayers: 3, gameTimer: 3, gameMode: 0 },
    //   { roomId: 'g8924', name: '#g8924 -- Farts123', players: 1, maxPlayers: 3, gameTimer: 2, gameMode: 0 },
    //   { roomId: 'g24h2', name: '#g24h2 -- Johnny', players: 2, maxPlayers: 3, gameTimer: 2, gameMode: 0 },
    //   { roomId: 'h5j6h', name: '#h5j6h -- Lollers', players: 1, maxPlayers: 2, gameTimer: 2, gameMode: 0 },
    //   { roomId: '4h35h', name: '#4h35h -- HardyHa', players: 1, maxPlayers: 2, gameTimer: 1, gameMode: 0 },
    //   { roomId: '4gh24', name: '#4gh24 -- ComeOnThen', players: 2, maxPlayers: 4, gameTimer: 3, gameMode: 0 },
    //   { roomId: 'gk5h3', name: '#gk5h3 -- FarmerBoi', players: 1, maxPlayers: 2, gameTimer: 1, gameMode: 0 },
    //   { roomId: '436f7', name: '#436f7 -- CloisterZ', players: 1, maxPlayers: 4, gameTimer: 2, gameMode: 0 },
    //   { roomId: '00hrh', name: '#00hrh -- RoadHOG', players: 1, maxPlayers: 2, gameTimer: 2, gameMode: 0 },
    //   { roomId: 'rgr0g', name: '#rgr0g -- GoldFIeld', players: 2, maxPlayers: 3, gameTimer: 0, gameMode: 0 }
    // ];

    // console.log("rooms", rooms);

    return (
      <>
        <div className='lobby-rooms-panel-section-tabs-container colour-dark-shade-bg'>
          { this.panelTabs.map( ( el, index ) => (
            <div className={ 'lobby-rooms-panel-section-tab-button'
              + ( selectedTabIndex === index
                ? ' lobby-rooms-panel-section-tab-button-selected colour-dark-accent-bg'
                : ' lobby-rooms-panel-section-tab-button-unselected' ) }
              key={ 'lobby-rooms-panel-section-tab-button-' + index }
              onClick={ async () =>
              {
                if( selectedTabIndex !== index )
                {
                  analytics.track( selectedTabIndex == 0 ? 'openSpectateTab' : 'openRoomsTab' );

                  this.setState( { selectedTabIndex: index } );

                  await this.updateRoomsListByIndex( index );

                  // Restart auto-refresh if it was enabled
                  if( autoRefreshEnabled )
                  {
                    this.startAutoRefresh();
                  }
                }
              } } >
              { this.panelTabs[ index ] }
            </div>
          ) ) }
        </div>

        <div className='lobby-rooms-panel-room-table-title-bar'>
          <div className='lobby-rooms-panel-title-text lobby-rooms-panel-title-bar-game'>GAME</div>
          <div className='lobby-rooms-panel-title-text lobby-rooms-panel-title-bar-speed'>SPEED</div>
          <div className='lobby-rooms-panel-title-text lobby-rooms-panel-title-bar-players'>PLAYERS</div>

          <div className='lobby-rooms-panel-auto-refresh-controls'>
            <label className='lobby-rooms-panel-auto-refresh-toggle'>
              <input
                type="checkbox"
                checked={ autoRefreshEnabled }
                onChange={ this.toggleAutoRefresh }
              />
              <span className='lobby-rooms-panel-auto-refresh-label'>Auto Refresh</span>
            </label>

            { autoRefreshEnabled && (
              <div className='lobby-rooms-panel-auto-refresh-progress-container'>
                <div
                  className='lobby-rooms-panel-auto-refresh-progress-bar'
                  style={ { width: `${autoRefreshProgress}%` } }
                />
              </div>
            ) }
          </div>

          <img className="lobby-rooms-panel-room-refresh-button" src={ process.env.PUBLIC_URL + '/ui/refresh-button.png' } alt="refresh rooms button"
            onClick={ async () =>
            {
              analytics.track( 'refreshRooms' );

              await this.updateCurrentRoomsList();

              // Restart auto-refresh if it was enabled (resets the timer)
              if( autoRefreshEnabled )
              {
                this.startAutoRefresh();
              }
            } } />
        </div>

        <div className='lobby-rooms-panel-room-list-container'>

          { roomsData.map( ( el, index ) => (
            <div className={ 'lobby-rooms-panel-room-line' + ( index % 2 === 0 ? ' colour-dark-shade-bg' : '' ) } key={ 'room-line-' + index }>

              <div className='lobby-rooms-panel-room-line-game-mode'>Base</div>

              <div className='lobby-rooms-panel-room-line-speed'>{ gameTimerModeNames[ el.gameTimer ] }</div>

              <div className='lobby-rooms-panel-room-line-players'>

                { [ ...Array( selectedTabIndex === SPECTATE_INDEX || el.rejoinable ? el.players : el.maxPlayers ) ].map( ( x, i ) =>
                  <img className='lobby-rooms-panel-room-line-player-icon'
                    key={ 'room-line-' + index + 'meeple-preview-' + i }
                    src={ process.env.PUBLIC_URL + ( i < el.players ? '/ui/room-player-slot-filled.png' : '/ui/room-player-slot-empty.png' ) }
                    alt="room player filled slot" />
                ) }

              </div>

              <div className='lobby-rooms-panel-room-line-join-button'>
                <form onSubmit={ this.onJoinRoom }>
                  <input type="hidden" name="roomId" value={ el.roomId } />

                  { selectedTabIndex === ROOMS_INDEX
                    ? ( el.rejoinable
                      ? (
                        <button
                          type="submit"
                          className='lobby-rooms-panel-room-line-rejoin-button-button colour-success-bg'
                          onClick={ () => { analytics.track( 'rejoinGame', { roomId: el.roomId, displayIndex: index, numPlayers: el.players, maxPlayers: el.maxPlayers } ); } }
                        >
                          Rejoin
                        </button>
                      )
                      : (
                        <button
                          type="submit"
                          className='lobby-rooms-panel-room-line-join-button-button colour-brand-bg'
                          onClick={ () => { analytics.track( 'joinGame', { roomId: el.roomId, displayIndex: index, numPlayers: el.players, maxPlayers: el.maxPlayers } ); } }
                        >
                          Join
                        </button>
                      ) )
                    : (
                      <button
                        type="submit"
                        className='lobby-rooms-panel-room-line-spectate-button-button colour-success-bg'
                        onClick={ () => { analytics.track( 'watchGame', { roomId: el.roomId, displayIndex: index, numPlayers: el.players, maxPlayers: el.maxPlayers } ); } }
                      >
                        Watch
                      </button>
                    )
                  }
                </form>
              </div>
            </div>
          ) ) }
        </div>

      </>
    );
  }
}
